import {
	EVENT_ACTION_REMOVE_VEHICLE,
	EVENT_CATEGORY_VEHICLE_MANAGEMENT,
	trackCustomEvent,
} from '../../../../shared/analytics';

export function trackRemoveVehicle() {
	trackCustomEvent({
		category: EVENT_CATEGORY_VEHICLE_MANAGEMENT,
		action: EVENT_ACTION_REMOVE_VEHICLE,
	});
}
